// @ts-nocheck
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import {
    BETLINE_SETTLEMENT_STATUSES,
    newDateAndTimeFormatWithSeconds,
    TICKET_STATUSES,
} from '../../../../utils/constants';
import { Button, Select, Tooltip } from 'antd';
import { HistoryOutlined, InfoCircleOutlined, RollbackOutlined } from '@ant-design/icons';

import styles from '../TicketIformation.module.scss';

const { Option } = Select;

const useTicketInformationColumns = ({
    isLive,
    handleSelectStatus,
    canUserSettleBetLine,
    handleClickRollback,
    openSettlementDrawer,
}) => {
    const ticketInfoModalProps = useSelector(state => state.global.ticketInfoModalProps);
    const { ticket, unSavedTicket } = ticketInfoModalProps;

    const columns = useMemo(
        () => [
            {
                key: 'live',
                title: 'Live',
                dataIndex: 'live',
                render: isLive => (isLive ? 'Yes' : 'No'),
            },
            {
                key: 'eventId',
                title: 'Event Id',
                dataIndex: 'eventId',
            },
            {
                key: 'sportName',
                title: 'Sport',
                dataIndex: 'sportName',
            },
            {
                key: 'league',
                title: 'Tournament',
                dataIndex: 'league',
            },
            {
                key: 'kickStartDate',
                title: 'Event Date',
                dataIndex: 'kickStartDate',
                render: record => moment(record).format(newDateAndTimeFormatWithSeconds),
            },
            {
                key: 'event',
                title: 'Event',
                dataIndex: 'event',
            },
            {
                key: 'marketName',
                title: 'Market',
                dataIndex: 'marketName',
            },
            {
                key: 'outcomeName',
                title: 'Selection',
                dataIndex: 'outcomeName',
            },
            {
                key: 'odds',
                title: 'Odds',
                dataIndex: 'odds',
            },
            isLive && {
                key: 'bettingScore',
                title: 'Score on Bets Placement',
                render: record => record.live && record.bettingScore,
            },
            {
                key: 'matchScore',
                title: 'Final Score',
                dataIndex: 'matchScore',
            },
            {
                key: 'status',
                title: 'Status',
                dataIndex: 'status',
                render: status => TICKET_STATUSES[status],
            },
            {
                key: 'settlementInfo',
                title: (
                    <div className={'flex align-center'}>
                        <span>Settlement Status</span>
                        {ticket.manuallySettled && (
                            <Tooltip placement={'top'} title={'Ticket has been manually settled'}>
                                <span className={'flex align-center cursor-pointer m-l-2'}>
                                    <HistoryOutlined className={styles.settlementHistory} />
                                </span>
                            </Tooltip>
                        )}
                    </div>
                ),
                render: ({ betLineId: id, logs }) => {
                    const foundUnsavedBetLine = unSavedTicket.betLines.find(betLine => id === betLine.betLineId);
                    const foundBetLine = ticket.betLines.find(betLine => id === betLine.betLineId);
                    const { settlementStatus, manuallySettled: unsavedManuallySettled } = foundUnsavedBetLine;
                    const { manuallySettled } = foundBetLine;
                    return (
                        <div className={'flex justify-between align-center'}>
                            <div className={'flex'}>
                                <Select
                                    className={`${styles.statusDropDown}`}
                                    style={{ width: '10rem' }}
                                    onSelect={value => handleSelectStatus(value, id)}
                                    value={unsavedManuallySettled && settlementStatus > 0 ? settlementStatus : ''}
                                    disabled={!canUserSettleBetLine}
                                >
                                    {BETLINE_SETTLEMENT_STATUSES.map(optionData => {
                                        return (
                                            <Option key={optionData.id} value={optionData.id}>
                                                {optionData.option}
                                            </Option>
                                        );
                                    })}
                                </Select>
                                {manuallySettled && canUserSettleBetLine && (
                                    <Tooltip placement='top' title={'Rollback'}>
                                        <Button
                                            type={'danger'}
                                            className={'m-l-4'}
                                            icon={<RollbackOutlined />}
                                            onClick={() => handleClickRollback(id)}
                                        />
                                    </Tooltip>
                                )}
                            </div>
                            <div className={'m-l-5'}>
                                <div className={'flex align-center'}>
                                    {logs?.length && ticket.manuallySettled && (
                                        <div className={'flex align-center'}>
                                            <InfoCircleOutlined
                                                className={styles.settlementInfo}
                                                onClick={() => openSettlementDrawer(logs)}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                },
            },
        ],
        [
            canUserSettleBetLine,
            handleClickRollback,
            handleSelectStatus,
            isLive,
            openSettlementDrawer,
            ticket.betLines,
            ticket.manuallySettled,
            unSavedTicket.betLines,
        ]
    );

    return columns;
};

export default useTicketInformationColumns;
